import { find, identical, pipe, prop } from 'ramda';
import { isStripeReader } from '../main/selectors';
import { openPayworks } from '../main/payment/actions';
import { PAYMENT_TYPE } from '../main/payment/constants';
import { PROCESS_CHARGE, CREATE_READER_TRANSACTION, PROCESS_WEBREADER_CHARGE } from '../register/payment/constants';
import { getHasCashPayment } from '../register/payment/reducer/payments/selectors';
import { openCashRegisterDrawer } from '../register/cashRegister/actions';
import * as paymentActions from '../register/payment/actions';
import { activeShopWebreader } from '../auth/selectors';

const paymentProcessingMiddleware = store => next => (action) => {
  const state = store.getState();

  const createTransaction = () => {
    store.dispatch(openPayworks(action.payload));
  };

  const processCharge = () => {
    const getPayments = prop('payments');
    const isReaderPayment = pipe(prop('type'), identical(PAYMENT_TYPE.reader));
    const readerPayment = pipe(getPayments, find(isReaderPayment))(action.payload);
    const hasWebreader = activeShopWebreader(state);

    if (getHasCashPayment(state)) store.dispatch(openCashRegisterDrawer());

    if (readerPayment && hasWebreader) {
      store.dispatch(paymentActions.createWebreaderTransaction(readerPayment, 'pay'));
      return;
    }

    if (readerPayment) {
      const { merchantInfo, sessionIdentifier: identifier, paymentIntentId, paymentIntentSecret } = readerPayment;
      store.dispatch(paymentActions.createReaderTransaction({
        merchantInfo,
        identifier,
        paymentIntentId,
        paymentIntentSecret,
        isStripeReader: isStripeReader(state),
      }));
      return;
    }

    store.dispatch(paymentActions.paymentSuccess(action.payload));
  };

  switch (action.type) {
    case CREATE_READER_TRANSACTION:
      createTransaction();
      break;

    case PROCESS_CHARGE:
      processCharge();
      break;

    case PROCESS_WEBREADER_CHARGE:
      processCharge();
      break;

    default:
  }

  next(action);
};

export default paymentProcessingMiddleware;
